import api from 'api';

export const loadCreativeTypes = ({ file, networkIds }) => {
  //.name - native file selected
  //.extension - extension field from file object from server

  const extension = file.extension
    ? file.extension
    : `.${file.name.split('.').pop()}`;

  return api('GET /api/gallery-creatives/fields/creative-types')({
    extension,
    networks: networkIds,
  });
};
export const loadColors = api('GET /api/gallery-creatives/fields/colors');
export const loadEnhancers = api('GET /api/gallery-creatives/fields/enhancers');
export const loadRequestedBy = api(
  'GET /api/gallery-creatives/fields/requested-by'
);
export const loadNetworks = api('POST /api/gallery-creatives/fields/networks');
export const loadTags = api('GET /api/gallery-creatives/fields/tags');
export const loadInheritTags = api(
  'GET /api/gallery-creatives/fields/inherit-tags'
);
export const loadChannels = api('GET /api/gallery-creatives/fields/channels');
export const loadAuthors = api('GET /api/gallery-creatives/fields/authors');
export const loadOS = api('GET /api/gallery-creatives/fields/os');
export const loadLanguages = api('GET /api/gallery-creatives/fields/languages');
export const loadApplications = api(
  'GET /api/gallery-creatives/fields/applications'
);

export const loadConcepts = api('GET /api/gallery-creatives/fields/concepts');
export const loadBusinessPartners = api(
  'GET /api/gallery-creatives/fields/business-partners'
);
export const loadAllBusinessPartners = api(
  'GET /api/gallery-creatives/fields/all-business-partners'
);
export const loadOutsourceStudios = api(
  'GET /api/gallery-creatives/fields/outsource-studios'
);
export const loadExclusiveForAffiliates = api(
  'GET /api/gallery-creatives/fields/exclusive-for-affiliates'
);
export const loadTested = api('GET /api/gallery-creatives/fields/tested');
export const loadProductionTypes = api(
  'GET /api/gallery-creatives/fields/production-types'
);
